"use client";
import React from "react";
import { usePathname } from "@/i18n/navigation";
import ArithmeticProgression from "../numberTools/arithmeticProgression/ArithmeticProgression";
import RoundNumber from "../numberTools/roundNumber/RoundNumber";
import GeomatricSeries from "../numberTools/geomatricSeries/GeomatricSeries";
import GenerateRandomNumber from "../numberTools/generateRandomNumber/GenerateRandomNumber";
import RomanToNumber from "../numberTools/romanToNumber/RomanToNumber";
import NumberToRoman from "../numberTools/numberToRoman/NumberToRoman";
import PrimeNumberSeries from "../numberTools/primeNumberSeries/PrimeNumberSeries";
import FibonacciNumberSeries from "../numberTools/fibonacciNumberSeries/FibonacciNumberSeries";
import CubeAndCuberoot from "../numberTools/CubandCubroot/CubeAndCuberoot";
import SquareAndSquareroot from "../numberTools/Square/SquareAndSquareroot";
import SumOfFirstNDigits from "../numberTools/sumOfFirstNDigit/SumOfFirstNDigits";
import SeriesOrdering from "../numberTools/seriesOrderingNumber/SeriesOrdering";
import PrimeFactors from "../numberTools/primeFactors/PrimeFactors";
import { ParaData } from "../common/CommonArray/FileArray";
import { HowToUseText } from "@/common/ToolPara";

const routeConfig = {
  "/generate-arithmetic-progression": {
    toolName: "Arithmetic Progression Generator",
    paraData: ParaData.ARITHMETIC_PROGRESSION,
  },
  "/geomatric-series": {
    toolName: "Geometric Series Calculator",
    paraData: ParaData.GEOMETRIC_SERIES,
  },
  "/prime-number-series": {
    toolName: "Prime Number Series Generator",
    paraData: ParaData.PRIME_NUMBER_SERIES,
  },
  "/fibonacci-number-series": {
    toolName: "Fibonacci Number Series Generator",
    paraData: ParaData.FIBONACCI_NUMBER_SERIES,
  },
  "/generate-random-number": {
    toolName: "Random Number Generator",
    paraData: ParaData.RANDOM_NUMBER_GENERATOR,
  },
  "/round-the-number": {
    toolName: "Number Rounding Tool",
    paraData: ParaData.ROUND_NUMBER,
  },
  "/roman-to-number": {
    toolName: "Roman to Number Converter",
    paraData: ParaData.ROMAN_TO_NUMBER,
  },
  "/number-to-roman": {
    toolName: "Number to Roman Converter",
    paraData: ParaData.NUMBER_TO_ROMAN,
  },
  "/cube-cuberoot": {
    toolName: "Cube and Cube Root Calculator",
    paraData: ParaData.CUBE_CUBEROOT,
  },
  "/Square-Squareroot": {
    toolName: "Square and Square Root Calculator",
    paraData: ParaData.SQUARE_SQUAREROOT,
  },
  "/Sum-Of-First-N-digits": {
    toolName: "Sum of First N Digits",
    paraData: ParaData.SUM_FIRST_N_DIGITS,
  },
  "/Series-Ordering-of-Numbers": {
    toolName: "Series Ordering of Numbers",
    paraData: ParaData.SERIES_ORDERING,
  },
  "/Prime-factors-of-Number": {
    toolName: "Prime Factors of a Number",
    paraData: ParaData.PRIME_FACTORS,
  },
};
function NumberToolFormat() {
  const pathName = usePathname();
  const currentRoute = routeConfig[pathName];

  return (
    <>
      {pathName === "/generate-arithmetic-progression" && (
        <ArithmeticProgression />
      )}
      {pathName === "/geomatric-series" && <GeomatricSeries />}
      {pathName === "/prime-number-series" && <PrimeNumberSeries />}
      {pathName === "/fibonacci-number-series" && <FibonacciNumberSeries />}
      {pathName === "/generate-random-number" && <GenerateRandomNumber />}
      {pathName === "/round-the-number" && <RoundNumber />}
      {pathName === "/roman-to-number" && <RomanToNumber />}
      {pathName === "/number-to-roman" && <NumberToRoman />}
      {pathName === "/cube-cuberoot" && <CubeAndCuberoot />}
      {pathName === "/Square-Squareroot" && <SquareAndSquareroot />}
      {pathName === "/Sum-Of-First-N-digits" && <SumOfFirstNDigits />}
      {pathName === "/Series-Ordering-of-Numbers" && <SeriesOrdering />}
      {pathName === "/Prime-factors-of-Number" && <PrimeFactors />}
      {currentRoute && (
        <HowToUseText
          toolName={currentRoute.toolName}
          firstPata={currentRoute.paraData.firstPara}
          secondPara={currentRoute.paraData.secondPara}
          toolData={currentRoute.paraData.toolData}
          howToUse={currentRoute.paraData.howToUse}
          whyUse={currentRoute.paraData.whyUse}
          commonUseCases={currentRoute.paraData.commonUseCases}
          features={currentRoute.paraData.features}
          faq={currentRoute.paraData.faq}
          tips={currentRoute.paraData.tips}
          relatedTools={currentRoute.paraData.relatedTools}
        />
      )}
    </>
  );
}

export default NumberToolFormat;
